var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex text-grey"},[_c('div',{staticClass:"flex justify-start w-1/2"},[_vm._v("\n    not so good\n ")]),_c('div',{staticClass:"flex justify-end w-1/2"},[_vm._v("\n    good\n ")])])
}]

export { render, staticRenderFns }